export default "__VITE_ASSET__C51MJzOk__"